/* Brillo theme — shared storefront behaviour. Progressive enhancement: every feature here
   enhances markup that already works without JavaScript (links, forms, native details). */
(function () {
  'use strict';

  var B = window.Brillo || (window.Brillo = {});
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || B.motion === false;
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  };
  B.store = store;
  B.reduceMotion = reduceMotion;

  /* ---------- Toast ---------- */
  var toastTimer;
  B.toast = function (msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  };

  /* ---------- Header height (scroll padding, sticky gallery) ---------- */
  function setHeaderVar() {
    var h = $('.section-header');
    var sticky = h && getComputedStyle(h).position === 'sticky';
    document.documentElement.style.setProperty('--header-sticky-h', (sticky ? h.offsetHeight : 0) + 'px');
  }
  window.addEventListener('resize', setHeaderVar, { passive: true });

  /* ---------- Drawers, overlays & modals (focus managed) ---------- */
  var openStack = [];
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';

  function panel(name) { return $('[data-drawer="' + name + '"]'); }
  function overlay(name) { return $('[data-overlay="' + name + '"]'); }

  B.open = function (name, trigger) {
    var p = panel(name); if (!p) return false;
    if (p.classList.contains('is-open')) return true;
    var o = overlay(name);
    p.classList.add('is-open'); if (o) o.classList.add('is-open');
    p.removeAttribute('aria-hidden');
    openStack.push({ name: name, trigger: trigger || document.activeElement });
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('is-locked');
    var target = $('[autofocus]', p) || $('[data-predictive-input]', p) || $('.close-btn', p) || p;
    setTimeout(function () { target.focus({ preventScroll: true }); }, 60);
    document.dispatchEvent(new CustomEvent('brillo:open', { detail: { name: name } }));
    return true;
  };
  B.close = function (name) {
    var p = panel(name); if (!p || !p.classList.contains('is-open')) return;
    var o = overlay(name);
    p.classList.remove('is-open'); if (o) o.classList.remove('is-open');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var idx = -1; openStack.forEach(function (e, i) { if (e.name === name) idx = i; });
    var entry = idx > -1 ? openStack.splice(idx, 1)[0] : null;
    if (!openStack.length) document.body.classList.remove('is-locked');
    pauseMediaIn(p);
    if (entry && entry.trigger && entry.trigger.focus) entry.trigger.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('brillo:close', { detail: { name: name } }));
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var name = opener.getAttribute('data-open');
      if (name === 'cart' && B.cartType === 'page') return;
      if (B.open(name, opener)) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); B.close(closer.getAttribute('data-close')); }
  });
  document.addEventListener('keydown', function (e) {
    if (!openStack.length) return;
    var top = openStack[openStack.length - 1];
    if (e.key === 'Escape') { e.preventDefault(); B.close(top.name); return; }
    if (e.key === 'Tab') {
      var p = panel(top.name);
      var f = $$(FOCUSABLE, p).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!f.length) { e.preventDefault(); p.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(el) {
    if (el.__init) return; el.__init = true;
    var msgs = $$('[data-ann-msg]', el); if (msgs.length < 2) return;
    var i = 0, timer = null;
    var interval = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    var auto = el.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) {
        var on = k === i;
        m.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (m.tagName === 'A') m.setAttribute('tabindex', on ? '0' : '-1');
      });
    }
    function start() { stop(); if (auto) timer = setInterval(function () { if (!document.hidden) show(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var p = $('[data-ann-prev]', el), n = $('[data-ann-next]', el);
    if (p) p.addEventListener('click', function () { show(i - 1); start(); });
    if (n) n.addEventListener('click', function () { show(i + 1); start(); });
    el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop); el.addEventListener('focusout', start);
    el.__select = function (blockEl) { var k = msgs.indexOf(blockEl); if (k > -1) { stop(); show(k); } };
    el.__destroy = stop;
    show(0); start();
  }

  /* ---------- Video & external media ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target; v.__inView = en.isIntersecting;
      if (en.isIntersecting) activateMedia(v); else pauseOne(v);
    });
  }, { rootMargin: '200px 0px' }) : null;

  function isHiddenContext(el) {
    var slide = el.closest('.hero__slide, .gallery__slide');
    if (slide && !slide.classList.contains('is-active')) return true;
    var drawer = el.closest('[data-drawer]');
    if (drawer && !drawer.classList.contains('is-open')) return true;
    return false;
  }
  function chooseSrc(v) {
    var m = v.getAttribute('data-src-mobile');
    return (m && mqMobile.matches) ? m : v.getAttribute('data-src');
  }
  function activateMedia(v) {
    if (isHiddenContext(v)) return;
    if (v.tagName === 'IFRAME') {
      if (reduceMotion) return;
      if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      return;
    }
    if (v.getAttribute('data-mode') !== 'background') return;
    var src = chooseSrc(v);
    if (!src) return;
    if (v.getAttribute('data-loaded') !== src) { v.src = src; v.setAttribute('data-loaded', src); }
    var toggle = v.parentElement && v.parentElement.querySelector('[data-video-toggle]');
    if (reduceMotion || v.__userPaused || !v.hasAttribute('data-autoplay')) {
      if (toggle) { toggle.hidden = false; toggle.textContent = '▶'; toggle.setAttribute('aria-label', B.strings.play || 'Play'); }
      v.classList.add('is-playing');
      return;
    }
    var pr = v.play();
    if (pr && pr.then) pr.then(function () {
      v.classList.add('is-playing');
      if (toggle) { toggle.hidden = false; toggle.textContent = '❚❚'; toggle.setAttribute('aria-label', B.strings.pause || 'Pause'); }
    }).catch(function () { /* autoplay blocked: poster stays visible */ if (toggle) { toggle.hidden = false; toggle.textContent = '▶'; } });
  }
  function pauseOne(v) {
    if (v.tagName === 'VIDEO' && !v.paused) v.pause();
  }
  function pauseMediaIn(root) {
    $$('video', root).forEach(function (v) { if (!v.paused) v.pause(); });
    $$('iframe[data-player]', root).forEach(function (f) { f.remove(); });
  }
  B.pauseMediaIn = pauseMediaIn;
  B.refreshMedia = function (root) {
    $$('video[data-video], iframe[data-external]', root).forEach(function (v) {
      if (isHiddenContext(v)) pauseOne(v); else if (v.__inView !== false) activateMedia(v);
    });
  };
  function initMedia(root) {
    $$('video[data-video], iframe[data-external]', root).forEach(function (v) {
      if (v.__init) return; v.__init = true;
      if (v.tagName === 'VIDEO' && v.getAttribute('data-mode') === 'player') {
        var src = chooseSrc(v); var s = v.querySelector('source');
        if (s && src && s.getAttribute('src') !== src) { s.setAttribute('src', src); v.load(); }
        return;
      }
      if (io) io.observe(v); else activateMedia(v);
    });
    $$('[data-video-toggle]', root).forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = b.parentElement.querySelector('video'); if (!v) return;
        if (v.paused) {
          v.__userPaused = false;
          if (!v.src) { var src = chooseSrc(v); if (src) { v.src = src; v.setAttribute('data-loaded', src); } }
          v.play().then(function () { v.classList.add('is-playing'); }).catch(function () {});
          b.textContent = '❚❚'; b.setAttribute('aria-label', B.strings.pause || 'Pause');
        } else {
          v.__userPaused = true; v.pause();
          b.textContent = '▶'; b.setAttribute('aria-label', B.strings.play || 'Play');
        }
      });
    });
    $$('[data-external-play]', root).forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var f = document.createElement('iframe');
        f.src = b.getAttribute('data-src'); f.title = b.getAttribute('data-title') || 'Video';
        f.className = 'media__el'; f.setAttribute('data-player', '');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen'); f.setAttribute('allowfullscreen', '');
        b.parentElement.appendChild(f); b.hidden = true; f.focus();
      });
    });
  }
  mqMobile.addEventListener && mqMobile.addEventListener('change', function () { B.refreshMedia(document); });
  document.addEventListener('visibilitychange', function () {
    $$('video[data-video][data-mode="background"]').forEach(function (v) {
      if (document.hidden) pauseOne(v); else if (v.__inView) activateMedia(v);
    });
  });

  /* ---------- Hero slideshow ---------- */
  function initSlideshow(el) {
    if (el.__init) return; el.__init = true;
    var slides = $$('[data-slide]', el); var n = slides.length;
    var dots = $$('[data-dot]', el), playBtn = $('[data-play]', el);
    var interval = (parseInt(el.getAttribute('data-interval'), 10) || 6) * 1000;
    var autoplay = el.getAttribute('data-autoplay') === 'true' && n > 1;
    var playing = autoplay && !reduceMotion;
    var hover = false, focus = false, editing = false, idx = 0, elapsed = 0, timer = null, tx = 0, ty = 0;

    function go(i) {
      if (!n) return;
      var prev = idx; idx = (i + n) % n; elapsed = 0;
      slides.forEach(function (s, k) {
        var on = k === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
        $$('a,button', s).forEach(function (a) { if (!a.closest('[data-video-toggle]')) a.setAttribute('tabindex', on ? '0' : '-1'); });
        if (!on) pauseMediaIn(s);
      });
      if (prev !== idx && slides[prev]) { slides[prev].classList.add('is-leaving'); setTimeout(function () { slides[prev] && slides[prev].classList.remove('is-leaving'); }, 950); }
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      var theme = slides[idx] && slides[idx].getAttribute('data-theme');
      if (theme) el.setAttribute('data-theme', theme);
      B.refreshMedia(slides[idx]);
    }
    function tick() {
      if (!playing || hover || focus || editing || n < 2 || document.hidden) return;
      elapsed += 200; if (elapsed >= interval) go(idx + 1);
    }
    function setPlaying(p) {
      playing = p;
      if (playBtn) {
        playBtn.textContent = p ? '❚❚' : '▶';
        playBtn.setAttribute('aria-label', p ? (B.strings.pause || 'Pause slideshow') : (B.strings.play || 'Play slideshow'));
      }
    }
    var prevBtn = $('[data-prev]', el), nextBtn = $('[data-next]', el);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (playBtn) playBtn.addEventListener('click', function () { setPlaying(!playing); });
    el.addEventListener('keydown', function (e) {
      if (e.target.matches('input,textarea,select')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });
    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    el.addEventListener('focusin', function () { focus = true; });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) focus = false; });
    el.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    setPlaying(playing);
    go(0);
    timer = setInterval(tick, 200);
    el.__select = function (blockEl) { var k = slides.indexOf(blockEl); if (k > -1) { editing = true; go(k); } };
    el.__deselect = function () { editing = false; };
    el.__destroy = function () { clearInterval(timer); };
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers(root) {
    $$('[data-scroll-target]', root).forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-scroll-target')); if (!t) return;
        var dir = b.getAttribute('data-dir') === 'prev' ? -1 : 1;
        t.scrollBy({ left: dir * t.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Cart (Shopify Ajax API + Section Rendering) ---------- */
  var cartBusy = false;
  function cartSections() {
    var ids = [];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    $$('[data-cart-section]').forEach(function (s) { ids.push(s.getAttribute('data-cart-section')); });
    return ids;
  }
  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var src = doc.querySelector('#CartDrawer-Inner'), dst = $('#CartDrawer-Inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
      } else {
        var s2 = doc.querySelector('[data-cart-section="' + id + '"]'), d2 = $('[data-cart-section="' + id + '"]');
        if (s2 && d2) d2.innerHTML = s2.innerHTML;
      }
    });
    initMedia($('#CartDrawer') || document);
  }
  function setCount(count) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = !count; });
    $$('[data-cart-link]').forEach(function (l) { l.setAttribute('aria-label', (l.getAttribute('aria-label') || '').replace(/\d+/, count)); });
  }
  function refreshCount() {
    return fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }).catch(function () {});
  }
  B.refreshCart = function () {
    var ids = cartSections();
    return fetch(B.routes.root + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); }).then(renderCartSections).then(refreshCount);
  };

  function errorText(data) {
    if (!data) return B.strings.cartError;
    return data.description || data.message || B.strings.cartError;
  }

  B.addToCart = function (form, submitter) {
    if (form.__busy) return Promise.resolve();
    form.__busy = true;
    var btn = submitter || $('[type="submit"][name="add"], [type="submit"]', form);
    var err = $('[data-form-error]', form) || (form.parentElement && $('[data-form-error]', form.parentElement));
    if (err) { err.textContent = ''; err.hidden = true; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var fd = new FormData(form);
    var ids = cartSections();
    if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
    return fetch(B.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = errorText(res.data);
          if (err) { err.textContent = msg; err.hidden = false; } else B.toast(msg);
          return;
        }
        document.dispatchEvent(new CustomEvent('brillo:cart:added', { detail: { item: res.data } }));
        if (B.cartType === 'page' || !$('#CartDrawer')) { window.location.href = B.routes.cart; return; }
        renderCartSections(res.data.sections);
        refreshCount();
        B.open('cart', btn);
      })
      .catch(function () {
        if (err) { err.textContent = B.strings.cartError; err.hidden = false; } else B.toast(B.strings.cartError);
      })
      .finally(function () {
        form.__busy = false;
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (B.cartType === 'page') return; // native submit → /cart
    e.preventDefault();
    B.addToCart(form, e.submitter);
  });

  function changeLine(lineEl, qty) {
    if (cartBusy) return;
    cartBusy = true;
    var key = lineEl.getAttribute('data-line-key');
    var drawer = $('#CartDrawer'); if (drawer) drawer.classList.add('is-busy');
    var errEl = $('[data-line-error]', lineEl); if (errEl) errEl.textContent = '';
    fetch(B.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          if (errEl) errEl.textContent = errorText(res.data);
          return B.refreshCart();
        }
        renderCartSections(res.data.sections);
        setCount(res.data.item_count);
        var line = $('[data-line-key="' + key + '"]');
        if (line && parseInt($('[data-qty-input]', line).value, 10) < qty) {
          var e2 = $('[data-line-error]', line); if (e2) e2.textContent = (B.strings.cartLimited || B.strings.cartError);
        }
      })
      .catch(function () { if (errEl) errEl.textContent = B.strings.cartError; })
      .finally(function () { cartBusy = false; if (drawer) drawer.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-qty-change]');
    var rm = e.target.closest('[data-line-remove]');
    var line = (ch || rm) && (ch || rm).closest('[data-line-key]');
    if (!line) return;
    e.preventDefault();
    if (rm) return changeLine(line, 0);
    var input = $('[data-qty-input]', line);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(ch.getAttribute('data-qty-change'), 10));
    input.value = next; changeLine(line, next);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) { var line = input.closest('[data-line-key]'); if (line) changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)); }
    var auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) auto.form.submit();
  });
  // Keep the bag in sync when the visitor comes back via the back/forward cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) B.refreshCart(); });

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = $('[data-predictive-input]'), out = $('[data-predictive-results]');
    if (!input || !out || input.__init) return; input.__init = true;
    var t, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (!q) { out.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = B.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
          if (!r.ok) throw new Error(r.status); return r.text();
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.shopify-section') || doc.body;
          out.innerHTML = sec.innerHTML;
          input.setAttribute('aria-expanded', 'true');
        }).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          out.innerHTML = '<p style="margin:6px 0;font-size:14px;color:var(--c-muted)">' + (B.strings.searchNoResults || '') + '</p>';
        });
      }, 220);
    });
  }

  /* ---------- Wishlist (device storage) ---------- */
  var WISH_KEY = 'brillo-wishlist';
  function wishList() { var l = store.get(WISH_KEY, []); return Array.isArray(l) ? l.filter(function (h) { return typeof h === 'string'; }) : []; }
  function syncWish() {
    var list = wishList();
    $$('[data-wish-toggle]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1, title = b.getAttribute('data-title') || '';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? B.strings.wishlistRemove : B.strings.wishlistAdd).replace('[title]', title));
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
    $$('[data-wish-link]').forEach(function (a) { a.setAttribute('aria-label', (B.strings.wishlistCount || 'Wishlist ([count])').replace('[count]', list.length)); });
  }
  B.wishlist = { list: wishList, sync: syncWish };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish-toggle]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-handle'), list = wishList(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    if (!store.set(WISH_KEY, list.slice(0, 60))) { B.toast('Your browser is blocking saved items.'); return; }
    syncWish();
    document.dispatchEvent(new CustomEvent('brillo:wishlist:change'));
  });
  window.addEventListener('storage', function (e) { if (e.key === WISH_KEY) syncWish(); });

  /* ---------- Product cards fetched by handle (wishlist, recently viewed) ---------- */
  function fetchCard(handle, view) {
    return fetch(B.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?view=' + (view || 'card'))
      .then(function (r) { if (!r.ok) throw new Error('missing'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-card-root] > *');
        if (!card || card.getAttribute('data-available') === 'hidden') throw new Error('unavailable');
        return card;
      });
  }
  B.renderCards = function (container, handles, opts) {
    opts = opts || {};
    var limit = opts.limit || 12;
    var jobs = handles.slice(0, limit).map(function (h) { return fetchCard(h, opts.view).then(function (c) { return { h: h, c: c }; }, function () { return { h: h, c: null }; }); });
    return Promise.all(jobs).then(function (rows) {
      container.innerHTML = '';
      var missing = [];
      rows.forEach(function (r) { if (r.c) container.appendChild(r.c); else missing.push(r.h); });
      initMedia(container); syncWish();
      return { count: container.children.length, missing: missing };
    });
  };

  function initWishlistPage(root) {
    var grid = $('[data-wishlist-grid]', root); if (!grid || grid.__init) return; grid.__init = true;
    var empty = $('[data-wishlist-empty]', root);
    function render() {
      var list = wishList();
      if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      B.renderCards(grid, list, { limit: 60 }).then(function (res) {
        if (res.missing.length) store.set(WISH_KEY, wishList().filter(function (h) { return res.missing.indexOf(h) === -1; }));
        if (!res.count && empty) empty.hidden = false;
        syncWish();
      });
    }
    render();
    document.addEventListener('brillo:wishlist:change', function () {
      var list = wishList();
      $$('[data-product-handle]', grid).forEach(function (card) { if (list.indexOf(card.getAttribute('data-product-handle')) === -1) card.remove(); });
      if (!grid.children.length && empty) empty.hidden = false;
    });
  }

  var RECENT_KEY = 'brillo-recent';
  B.recordRecent = function (handle) {
    if (!handle) return;
    var l = store.get(RECENT_KEY, []); if (!Array.isArray(l)) l = [];
    l = [handle].concat(l.filter(function (h) { return h !== handle; })).slice(0, 16);
    store.set(RECENT_KEY, l);
  };
  function initRecent(root) {
    $$('[data-recent]', root).forEach(function (sec) {
      if (sec.__init) return; sec.__init = true;
      var current = sec.getAttribute('data-current');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
      var list = store.get(RECENT_KEY, []); if (!Array.isArray(list)) list = [];
      list = list.filter(function (h) { return h && h !== current; });
      var track = $('[data-recent-track]', sec);
      if (!list.length || !track) { sec.hidden = true; return; }
      B.renderCards(track, list, { limit: limit, view: 'card-compact' }).then(function (res) {
        if (res.missing.length) store.set(RECENT_KEY, store.get(RECENT_KEY, []).filter(function (h) { return res.missing.indexOf(h) === -1; }));
        sec.hidden = res.count === 0;
      });
    });
  }

  /* ---------- Back to top ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-back-to-top]'); if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    var main = document.getElementById('MainContent'); if (main) main.focus({ preventScroll: true });
  });

  /* ---------- Init + theme editor support ---------- */
  function init(root) {
    root = root || document;
    $$('[data-announcement]', root).forEach(initAnnouncement);
    $$('[data-slideshow]', root).forEach(initSlideshow);
    initMedia(root); initScrollers(root); initSearch(); initWishlistPage(root); initRecent(root);
    syncWish(); setHeaderVar();
    document.dispatchEvent(new CustomEvent('brillo:init', { detail: { root: root } }));
  }
  B.init = init;

  function destroyIn(root) {
    $$('[data-slideshow], [data-announcement]', root).forEach(function (el) { if (el.__destroy) el.__destroy(); el.__init = false; });
    pauseMediaIn(root);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest('[data-slideshow], [data-announcement]');
    if (host && host.__select) host.__select(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var host = e.target.closest('[data-slideshow]');
    if (host && host.__deselect) host.__deselect();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) B.open('cart');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('#CartDrawer')) B.close('cart');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
